import { create } from 'zustand';

import RelationController from '@/api/relation/relation.ts';
import { RelationKind } from '@/enums/apiEnums.ts';
import { catchErrors } from '@/utils/sentry-monitor.tsx';

interface SummariesStore {
  likesCount: number | undefined;
  getLikesCount: () => Promise<void>;
  incrementLikesCount: () => void;
  setLikesCount: (quantity: number) => void;
}

export const useSummariesStore = create<SummariesStore>((set, get) => ({
  likesCount: undefined,
  getLikesCount: async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 500)); // just to show skeleton

      const summaries = await RelationController.getSummariesByKinds([
        RelationKind.KIND_LIKES_YOU
      ]);
      const likesSummary = summaries.find(
        (summary) => summary.kind === RelationKind.KIND_LIKES_YOU
      );
      const likesCount = likesSummary?.total_amount || 0;

      set({ likesCount });
    } catch (e) {
      set({ likesCount: 0 });

      catchErrors(e, true);
    }
  },
  incrementLikesCount: () => {
    const currentCount = get().likesCount ?? 0;
    set({ likesCount: currentCount + 1 });
  },
  // on every decrement event we should ask backend for likes count
  setLikesCount: (quantity) => {
    set({ likesCount: quantity });
  }
}));
